import React, { Component } from 'react'
import Header from '../Header'
import './IVbw.css'

class IVbw extends Component {
  
    render () {
        return (
            <div>
                <Header />
                <div className="bodyIVbw">
                    <p className="textIVbw">A venir...</p>
                </div>
            </div>
        )
    }
}

export default IVbw